import React, { useEffect, useRef } from "react";
import { RapidStorPaymentResult } from "../../services/rapidstor";

interface Props {
  onPaymentResult?: (result: RapidStorPaymentResult) => void;
  paymentLink: string;
}

function PaymentModal(props: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (iframeRef.current && e.source == iframeRef.current.contentWindow) {
        // const result = e.data as RapidStorPaymentResult;
        const result: RapidStorPaymentResult = {
          error: e.data.error ?? null,
          code: e.data.code ?? null,
          message: e.data.message ?? null,
        };

        if (props.onPaymentResult) {
          props.onPaymentResult(result);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={props.paymentLink}
      style={{ width: "100%", height: "350px" }}
    />
  );
}

export default PaymentModal;
